var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{staticClass:"purchase-list pagination"},[_c('el-card',{staticClass:"contains-table",attrs:{"shadow":"always"}},[_c('Shipping',{attrs:{"id":"sales-shipping","context":"SALES"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }